import React, { useCallback, useContext, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import FormLabel from 'react-bootstrap/FormLabel';

import { NCRContext } from "views";

import { File } from 'components/form/prototypes'

const FileUploads = () => {

  const { state, setState } = useContext(NCRContext);
  const [uploadHtml, setUploadHtml] = useState([]);

  /**
   * FUNCTION: deleteFile
   * deletes a given file from the NCR
   * @param uuid - the unique id for the product we're removing
   */
  const deleteFile = useCallback(uuid => {
    setState(prev => {
      let index = prev.uploads.findIndex(file => file.uuid === uuid);
      prev.uploads = [...prev.uploads];
      prev.uploads.splice(index, 1);
      return { ...prev };
    });
  }, [setState]);

  /**
   * The useEffect below update the NCR when there is a file removed or added to the NCR
   * @param uploadHtml - holds the html to be rendered in the component
   */
  useEffect(() => {
    if (uploadHtml.length !== state.uploads.length) {
      setUploadHtml(
        state.uploads.map(file => {
          let uuid = uuidv4();
          file.uuid = uuid;
          return (
            <File id={uuid}
              upload={true}
              key={uuid}
              file={file}
              callBackFunctionDelete={() => deleteFile(uuid)}
            />
          )
        })
      );
    }
  }, [deleteFile, uploadHtml, setState, state.uploads]);

  return (
    <>
      <FormLabel>Uploads:</FormLabel>
      {uploadHtml.length > 0
        ?
        uploadHtml
        :
        <Row>
          <Col>
            <FormControl disabled defaultValue='No files to upload' />
          </Col>
        </Row>
      }
    </>
  )
}

export { FileUploads };
